<div class="client-service" fxLayout="row nowrap">
  <img alt="" src="assets/images/carolina2.png" >
  <div class="" fxLayout="column wrap" fxFlex>
    <a routerLink="/account/client-service">{{ 'globalUi.clientService' | translate }}</a>
    <a href="mailto:info-wiunivers@wissalgroup.com">info-wiunivers&#64;wissalgroup.com</a>
    <a href="tel:0770 61 77 16">0770 61 77 16</a>
  </div>
</div>
